import { combineReducers } from '@reduxjs/toolkit';
import { withReduxStateSync } from 'redux-state-sync';

import editorReducer from './editor/editorSlice';
import jwtReducer from './jwtSlice';
import tabsSyncReducer from './tabsSyncSlice';
import toastReducer from './toastSlice';

const rootReducer = combineReducers({
	courses: editorReducer,
	jwt: jwtReducer,
	tabsSync: tabsSyncReducer,
	toast: toastReducer
});

export type RootState = ReturnType<typeof rootReducer>;

export default withReduxStateSync(rootReducer);
